var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_16335",
    "data-name": "Group 16335",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2089",
    "data-name": "Rectangle 2089",
    width: 38.379,
    height: 39,
    transform: "translate(0.244)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hand-shake",
    transform: "translate(0 5.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15866",
    "data-name": "Group 15866",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15865",
    "data-name": "Group 15865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8052",
    "data-name": "Path 8052",
    d: "M11.508,108.849c-1.587-1.587-8.333-1.984-10.516-2.183a.729.729,0,0,0-.6.2,1.5,1.5,0,0,0-.4.794v17.858a.937.937,0,0,0,.992.992H6.945a1.091,1.091,0,0,0,.992-.6c0-.6,3.571-11.111,3.968-16.27A.792.792,0,0,0,11.508,108.849Z",
    transform: "translate(0 -106.666)",
    fill: "#f9b316"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15868",
    "data-name": "Group 15868",
    transform: "translate(11.456 4.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15867",
    "data-name": "Group 15867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8053",
    "data-name": "Path 8053",
    d: "M196.96,154.244c-1.984-.6-3.77-1.389-5.357-1.984-3.571-1.587-5.159-.794-8.333,2.381-1.389,1.389-2.381,3.373-2.183,4.167,0,.2,0,.2.4.4.992.4,2.381.6,3.77-1.587a1.031,1.031,0,0,1,.794-.4,3.678,3.678,0,0,0,1.389-.4,9.677,9.677,0,0,1,1.389-.6h.4c.2,0,.6.2.794.2.992.992,2.778,2.381,4.564,3.968a45.447,45.447,0,0,1,6.945,6.349h.2C200.333,162.776,197.952,156.03,196.96,154.244Z",
    transform: "translate(-181.061 -151.467)",
    fill: "#f9b316"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15870",
    "data-name": "Group 15870",
    transform: "translate(25.111 1.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15869",
    "data-name": "Group 15869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8054",
    "data-name": "Path 8054",
    d: "M375.563,128a34.794,34.794,0,0,0-12.3,1.984l-.6.6a1.193,1.193,0,0,0,.2.794c1.19,1.984,5.159,12.9,5.754,15.675a1.318,1.318,0,0,0,.992.794h5.952a.937.937,0,0,0,.992-.992V128.992A.937.937,0,0,0,375.563,128Z",
    transform: "translate(-362.666 -128)",
    fill: "#f9b316"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15872",
    "data-name": "Group 15872",
    transform: "translate(6.248 5.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15871",
    "data-name": "Group 15871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8055",
    "data-name": "Path 8055",
    d: "M136.53,186.144c-.794-1.786-4.167-4.365-7.143-6.746-1.587-1.389-3.175-2.579-4.365-3.572-.2.2-.6.2-.6.4a3.738,3.738,0,0,1-1.587.4c-1.587,1.984-3.571,2.778-5.754,1.984a2.346,2.346,0,0,1-1.786-1.786c-.4-1.984,1.389-4.762,2.778-6.151h-3.968a101.164,101.164,0,0,1-3.175,11.905,22.433,22.433,0,0,0,2.183,2.183c3.77,3.175,8.135,6.349,8.929,6.945a5.64,5.64,0,0,0,2.381.794h.6l-3.175-3.175a.982.982,0,0,1,1.389-1.389L127.2,191.9c.4.4.794.2,1.19.2.6-.2.794-.6.992-1.19l-4.564-4.564a.982.982,0,0,1,1.389-1.389l4.96,4.96a2.122,2.122,0,0,0,1.587,0c.2-.2.6-.4.794-.794L128,183.564a.982.982,0,0,1,1.389-1.389l5.754,5.754a1.312,1.312,0,0,0,1.19-.2A1.347,1.347,0,0,0,136.53,186.144Z",
    transform: "translate(-110.934 -170.667)",
    fill: "#f9b316"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy2);
export default __webpack_public_path__ + "static/media/why2.a36b4f237dfebab203ab8a2c002b8b34.svg";
export { ForwardRef as ReactComponent };